import './Loading.scss';

export const Loading = (props) => {

    return <div className={`ficheLoadingScreen`}>
        <i class="fa fa-spinner fa-pulse ficheLoadingScreenIcon"></i>
    </div>
}